import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import CalendarBookingRequestsPriceController from 'uplisting-frontend/pods/xcalendar/booking-requests/price/controller';

export default abstract class SidebarBookingRequestsPriceRoute extends PermittedRoute {
  @service('repositories/property')
  propertyRepository!: Services['repositories/property'];

  permission = 'calendar.booking-requests.price';
  abstract parentRoute: string;

  model() {
    const bookingRequest = this.modelFor(
      this.parentRoute,
    ) as ModelRegistry['booking-request'];

    return this.propertyRepository
      .findRecord(bookingRequest.property.id, {
        reload: true,
      })
      .then(() => bookingRequest);
  }

  setupController(
    controller: CalendarBookingRequestsPriceController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { bookingRequest: model });
  }
}
